import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { TEXT_KEYS, FOOTER_LOGO_CLASSNAMES, ANALYTICS_ACTION } from './footer.constants';
import { REGIONS } from '@sitegen/common/constants';
import { IFooterLogoItem, IFooterLogoPlatformItem, IFooterLink } from './footer.types';

export const logosList: IFooterLogoItem[] = [
    {
        className: FOOTER_LOGO_CLASSNAMES.UBISOFT,
        href: 'https://www.ubisoft.com',
        analyticsAction: ANALYTICS_ACTION.UBISOFT
    },
    {
        className: FOOTER_LOGO_CLASSNAMES.CONNECT,
        href: 'https://uplay.ubi.com/',
        analyticsAction: ANALYTICS_ACTION.UPLAY
    },
    {
        className: FOOTER_LOGO_CLASSNAMES.USTORE,
        href: 'http://store.ubi.com',
        analyticsAction: ANALYTICS_ACTION.UBISOFT_STORE
    }
];

export const regionLinksList: {[key: string]: IFooterLink[] } = {
    [REGIONS.US]: [{
        key: TEXT_KEYS.FOOTER_DO_NOT_SELL_MY_INFO,
        href: 'https://legal.ubi.com/privacypolicy/',
        analyticsAction: ANALYTICS_ACTION.DONT_SELL_MY_INFO
    }],
    [REGIONS.EMEA]: [{
        key: TEXT_KEYS.FOOTER_MANAGE_COOKIES,
        href: '',
        analyticsAction: ANALYTICS_ACTION.INIT_PRIVACY_OPTIONS
    }]
};

export const platformLogosList: IFooterLogoPlatformItem[] = [
    {
        platformId: PLATFORM_TYPES.EPIC,
        className: FOOTER_LOGO_CLASSNAMES.EPIC,
        href: 'https://www.epicgames.com',
        analyticsAction: ANALYTICS_ACTION.EPICGAMES
    },
    {
        platformId: PLATFORM_TYPES.PS4,
        className: FOOTER_LOGO_CLASSNAMES.PS4,
        href: 'http://www.playstation.com',
        analyticsAction: ANALYTICS_ACTION.PLAYSTATION
    },
    {
        platformId: PLATFORM_TYPES.PS5,
        className: FOOTER_LOGO_CLASSNAMES.PS5,
        href: 'http://www.playstation.com',
        analyticsAction: ANALYTICS_ACTION.PLAYSTATION
    },
    {
        platformId: PLATFORM_TYPES.XONE,
        className: FOOTER_LOGO_CLASSNAMES.XBOX1,
        href: 'http://www.xbox.com',
        analyticsAction: ANALYTICS_ACTION.XBOX
    },
    {
        platformId: PLATFORM_TYPES.XSX,
        className: FOOTER_LOGO_CLASSNAMES.XBOXX,
        href: 'http://www.xbox.com',
        analyticsAction: ANALYTICS_ACTION.XBOX
    },
    {
        platformId: PLATFORM_TYPES.STADIA,
        className: FOOTER_LOGO_CLASSNAMES.STADIA,
        href: 'https://stadia.com',
        analyticsAction: ANALYTICS_ACTION.STADIA
    },
    {
        platformId: PLATFORM_TYPES.SWITCH,
        className: FOOTER_LOGO_CLASSNAMES.SWITCH,
        href: 'https://www.nintendo.com',
        analyticsAction: ANALYTICS_ACTION.NINTENDO
    },
    {
        platformId: PLATFORM_TYPES.LUNA,
        className: FOOTER_LOGO_CLASSNAMES.LUNA,
        href: 'https://www.amazon.com/luna',
        analyticsAction: ANALYTICS_ACTION.LUNA
    }
];

export const linksList: IFooterLink[] = [
    {
        key: TEXT_KEYS.FOOTER_CUSTOMER_SUPPORT,
        href: 'https://support.ubi.com',
        analyticsAction: ANALYTICS_ACTION.CUSTOMER_SUPPORT
    },
    {
        key: TEXT_KEYS.FOOTER_TERMS_OF_USE,
        href: 'https://legal.ubi.com/termsofuse',
        analyticsAction: ANALYTICS_ACTION.TERMS_OF_USE
    },
    {
        key: TEXT_KEYS.FOOTER_LEGAL_INFORMATION,
        href: 'https://legal.ubi.com',
        analyticsAction: ANALYTICS_ACTION.LEGAL_INFORMATION
    },
    {
        key: TEXT_KEYS.FOOTER_PRIVACY_POLICY,
        href: 'https://legal.ubi.com/privacypolicy',
        analyticsAction: ANALYTICS_ACTION.PRIVACY_POLICY
    }
];

export default {
    logosList,
    regionLinksList,
    platformLogosList,
    linksList
};
